import { forwardRef } from 'react';
import { StyledMeasurementBlock, StyledMeasurementList, StyledMeasurementListItem } from './MeasurementBlock.styles';

type MeasurementListProps = Omit<JSX.IntrinsicElements['ul'], 'ref'> & {
  isOneSizeProduct?: boolean;
};

export function MeasurementList({ children, isOneSizeProduct, ...props }: MeasurementListProps) {
  return (
    <StyledMeasurementList {...props} $isOneSizeProduct={isOneSizeProduct} data-testid="sizesList">
      {children}
    </StyledMeasurementList>
  );
}

type MeasurementListItemProps = Omit<JSX.IntrinsicElements['li'], 'ref'> & {
  isTwoSpaces?: boolean;
};

export function MeasurementListItem({ children, isTwoSpaces, ...props }: MeasurementListItemProps) {
  return (
    <StyledMeasurementListItem {...props} $isTwoSpaces={isTwoSpaces}>
      {children}
    </StyledMeasurementListItem>
  );
}

type MeasurementBlockProps = Omit<JSX.IntrinsicElements['button'], 'ref'>;

export function MeasurementBlock({ children, ...props }: MeasurementBlockProps) {
  return <StyledMeasurementBlock {...props}>{children}</StyledMeasurementBlock>;
}

type MeasurementBlockLinkProps = Omit<JSX.IntrinsicElements['a'], 'ref'>;

export const MeasurementBlockLink = forwardRef<HTMLAnchorElement, MeasurementBlockLinkProps>(
  ({ children, ...props }, ref) => (
    <StyledMeasurementBlock as="a" ref={ref} {...props}>
      {children}
    </StyledMeasurementBlock>
  ),
);
